import { render, staticRenderFns } from "./data-type-input.vue?vue&type=template&id=ed8d68e0&scoped=true&"
import script from "./data-type-input.vue?vue&type=script&lang=js&"
export * from "./data-type-input.vue?vue&type=script&lang=js&"
import style0 from "./data-type-input.vue?vue&type=style&index=0&id=ed8d68e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8d68e0",
  null
  
)

export default component.exports